<template>
	<div class="flex">
		<button
			type="button"
			class="rounded-s-md"
			:class="incrementClasses"
			:disabled="disabled"
			data-testid="minus-button"
			@click="(event) => updateValue(event, +normalizedModelValue! - 1)">
			<font-awesome-icon icon="fa-minus" class="text-xs text-gray-900" />
		</button>
		<input
			type="text"
			pattern="[0-9]*"
			inputmode="numeric"
			:value="normalizedModelValue"
			:class="quantityClasses"
			placeholder="1"
			:disabled="disabled"
			@blur="updateValue" />
		<button
			type="button"
			class="rounded-e-md"
			:class="incrementClasses"
			:disabled="disabled"
			data-testid="plus-button"
			@click="(event) => updateValue(event, Number(normalizedModelValue) + 1)">
			<font-awesome-icon icon="fa-plus" class="text-xs text-gray-900" />
		</button>

		<button
			v-if="max"
			type="button"
			class="rounded-md ms-4"
			:class="incrementClasses"
			:disabled="disabled"
			data-testid="max-button"
			@click="(event) => updateValue(event, Number(max))">
			<span class="text-xs">Max</span>
		</button>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	const props = withDefaults(
		defineProps<{
			modelValue: number | string | null
			max?: number | string
			disabled?: boolean
		}>(),
		{
			max: undefined,
			disabled: false
		}
	)

	const normalizedModelValue = computed(() => {
		return props.modelValue === null ? 0 : props.modelValue
	})

	const quantityClasses = computed(() => {
		let classes = `bg-gray-50 border-x-0 border-gray-300 text-center text-gray-900 text-sm block h-8 py-2.5 w-14`

		if (props.disabled) {
			classes += ' cursor-not-allowed opacity-50'
		}

		return classes
	})

	const incrementClasses = computed(() => {
		let classes = 'h-8 bg-gray-100 border border-gray-300 py-1 px-2 focus:outline-none'

		if (props.disabled) {
			classes += ' cursor-not-allowed opacity-50'
		} else {
			classes += ' hover:bg-gray-200'
		}

		return classes
	})

	const emit = defineEmits(['update:modelValue'])

	function updateValue(e: Event, value?: number) {
		const val = Number(value ? value : (e.target as HTMLInputElement).value)
		const max = props.max ? Number(props.max) : undefined

		if (max && val > max) {
			emit('update:modelValue', max)
		} else if (val >= 0 && (!max || val <= max)) {
			emit('update:modelValue', val)
		} else {
			emit('update:modelValue', 0)
		}
	}
</script>
